<template>
  <div class="color-sections">
    <color-section
      v-for="(section, index) in sections"
      :key="index"
      :colorPickers="section.ColorPickers"
      :iconSrc="section.IconSrc"
      :id="section.Id"
      :title="section.Title"
    ></color-section>
  </div>
</template>

<script>
import Vue from 'vue';
import Component from "vue-class-component";
import { Prop } from 'vue-property-decorator';
import { mapState } from 'vuex';
import ColorSection from '@/components/buy-guide/components/color-section/color-section.vue';
//
@Component({
    props: {
    },
    computed: {
      ...mapState({
          currentStepIndex: state => state.buyGuide.currentStepIndex,
          steps: state => state.buyGuide.steps,
          status: state => state.buyGuide.status,
          results: state => state.buyGuide.results
      }),
    },
    components: {
      'color-section': ColorSection
    },
    methods: {
    }
})
export default class ColorsMaterials extends Vue {
  @Prop() type;
  @Prop() sections;
  @Prop() getNumberOfColumns;


}

</script>

<style>

</style>
